import React, { MouseEvent, FocusEvent, ReactNode, createRef } from "react"

import Input from "../../libs/ui/inputs/Input"
import { getSvgError } from "../../libs/ui/icons/svg"

import { isEmpty } from "../../libs/validation/stringRegex"
import { authFetch } from "../../libs/cookie/Cookie"

import { ADDRESS_SEARCH_URL, ADDRESS_DETAILS_URL } from "../../costants"
import { STREET_NUMBER_PATTERN, STREET_ADDRES_PATTERN, isValid } from "../../libs/validation/stringRegex"

import { BaseComponent, BaseProps, BaseState } from "../../libs/ui/BaseComponent" 

interface AutoSelectionAddressProps extends BaseProps {
    value: string | undefined      // il valore -- INDIRIZZO
    
    street: string | undefined
    number: string | undefined
    zip: string | undefined
    city: string | undefined

    error: string | undefined       // erore sul indirizzo (nella sua totalita)
    streetError: string | undefined
    numberError: string | undefined
    zipError: string | undefined
    cityError: string | undefined

    updateNumber?: Function
    
    clearError?: Function
    clearNumberError?: Function

    expiredSessionCallbak?: Function
}

interface AutoSelectionAddressState extends BaseState {
    value: string | undefined
    selectedId: string | undefined
    showCivico: boolean
    matches: any[]
    session: string | undefined

    hasFocus: boolean
    isDeleteAction: boolean
}

export interface Place {
    placeId: string, 
    description: string 
}

/**
 * gli attributi sicuramente gestiti -- quelli da non riscrivere
 */
const defaults : AutoSelectionAddressProps = {
    id: undefined,
    className: 'form-control-lg',
    type:'text',

    value: undefined,
    street: undefined,
    number: undefined,
    zip: undefined,
    city: undefined,

    error: undefined,
    streetError: undefined,
    numberError: undefined,
    zipError: undefined,
    cityError: undefined,

    callback: undefined,
    updateNumber: undefined,

    clearError: undefined,
    clearNumberError: undefined,

    onFocus: undefined,
    onBlur: undefined,
    onChange: undefined,
    
    expiredSessionCallbak: undefined,
    
    errorDisplayMsg: undefined,
}

class AutoSelectionAddress extends BaseComponent<AutoSelectionAddressProps, AutoSelectionAddressState> {
    private addressInput: React.RefObject<HTMLInputElement>
    private numberInput: React.RefObject<HTMLInputElement>

    private timeOut: ReturnType<typeof setTimeout> | undefined
    private abortController: AbortController | undefined


    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props} as AutoSelectionAddressProps

        this.state = {
            value: this.getInitialAddressValue(),
            selectedId: undefined,
            validationError: this.props.error ?? 
                this.props.streetError ?? this.props.numberError ??
                this.props.zipError ?? this.props.cityError,
            showCivico: false,
            matches: [],
            session: undefined,

            hasFocus: false,
            isDeleteAction: false,
        }

        this.addressInput = createRef()
        this.numberInput = createRef()

        this.timeOut = undefined
        this.abortController = undefined

        this.getInitialAddressValue = this.getInitialAddressValue.bind(this)
        this.validate = this.validate.bind(this)
        this.getAutoCompleteabel = this.getAutoCompleteabel.bind(this)
        this.printAutoCompliteInput = this.printAutoCompliteInput.bind(this)
        this.onEdit = this.onEdit.bind(this)
        this.onFocuskHandler = this.onFocuskHandler.bind(this)
        this.updatePartialValue = this.updatePartialValue.bind(this)
        this.getMatches = this.getMatches.bind(this)
        this.getRemoteChoice = this.getRemoteChoice.bind(this)
        this.selectValue = this.selectValue.bind(this)
        this.getDetails = this.getDetails.bind(this)
        this.updateNumber = this.updateNumber.bind(this)
        this.clearNumberError = this.clearNumberError.bind(this)
        this.expiredSession = this.expiredSession.bind(this)
    }

    componentDidUpdate(
        prevProps: Readonly<AutoSelectionAddressProps>, 
        prevState: Readonly<AutoSelectionAddressState>, 
        snapshot?: any
    ): void {
        // evito la perdita del focus quando rimuovo lo span di errore
        /*
        if (
            prevProps.error !== undefined &&  prevProps.error !== '' &&
            (this.props.error === undefined || this.props.error === '') &&
            document.activeElement?.id !== this.addressInput.current?.id &&
            (document.activeElement?.id !== undefined && document.activeElement?.id === '')
        ) {
            // se prima avevo un errore e ora no --> lo span di errore non viene più disegnato
            // quindi il component fa un re - render --> quindi rido il focus
            this.addressInput.current?.focus()
        }
        */
        // decido se il civico deve rimane visibile
        if (
            prevState.showCivico === true && this.state.showCivico === true &&
            !isEmpty( this.props.number ) && this.props.number === null
        ) {
            this.setState ({
                showCivico: false
            })
        }
    }

    render (): ReactNode {
        const attributes = this.getPropertyDifferences (this.mergedProps ?? {}, defaults)

        const labelTag = this.getAutoCompleteabel()
        const errorTag = this.getTextError()

        const classString = 
            (this.props.value !== undefined && errorTag === undefined ? 'is-ok ' : '') +
            (this.state.hasFocus ? 'focus ' : '') +
            (
                (this.props.className ?? '') === 'form-control-lg' 
                    ? this.props.className + ' form-control-lg'
                    : 'form-control-lg' 
            ) + 
            (errorTag !== undefined ? ' is-invalid' : '')

        return (
            this.props.id &&
                <div className='col-12 downshift-container'>
                    {labelTag !== undefined && labelTag}

                    {
                        errorTag !== undefined && !this.state.showCivico 
                        ?   <div className='input-group'>
                                {this.printAutoCompliteInput( classString, attributes )}

                                <span className="input-group-text">
                                    {errorTag}
                                </span>
                            </div>
                        :   this.printAutoCompliteInput( classString, attributes )
                    }
                </div>
        )
    }

    private getInitialAddressValue () {

        if (this.props.value === undefined) {
            // già formattato correttamente
            if ( isValid(this.props.street, STREET_ADDRES_PATTERN) && this.props.street?.endsWith('ITALIA')) {
                return this.props.street
            }
            else if (
                !isEmpty(this.props.street) && isEmpty(this.props.streetError) &&
                !isEmpty(this.props.number) && isEmpty(this.props.numberError) &&
                !isEmpty(this.props.zip) && isEmpty(this.props.zipError) &&
                !isEmpty(this.props.city) && isEmpty(this.props.cityError)
            ) {
                return this.props.street + ', ' +
                    this.props.number + ', ' +
                    this.props.zip + ' ' +
                    this.props.city + ', ITALIA'
            }
        }

        return this.props.value

    }

    private getAutoCompleteabel () {
        const hasError = (this.props.error ?? this.state?.validationError)
        const labelClass = (hasError !== undefined) ? 'is-invalid form-label' : 'form-label'

        return ( this.props.label && this.props.id )
            ?   <label 
                    id={'downshift-' + this.props.id + '-label'}
                    className={labelClass}
                    htmlFor={`${this.props.id}`}
                >
                    {hasError && getSvgError()}
                    {this.props.label}
                </label>
            :   undefined
    }

    private printAutoCompliteInput (classString: string, attributes: any) {
        const DROP_ID = 'downshift-' + this.props.id
        const LABEL_ID = DROP_ID + '-label'
        const UL_ID = DROP_ID + '-menu'
        const LI_PARTIAL_ID = DROP_ID + '-suggestion-'

        const suggestionClassName = (this.state.matches !== undefined && this.state.matches.length > 0)
            ? 'downshift-suggestion'
            : 'hidden'

        return (
            <>
                <input
                    id={this.props.id}
                    role='combobox'
                    value={this.state.value ?? ''}

                    className={classString}

                    type='search'
                    inputMode='search'

                    autoComplete='off'
                    autoFocus={false}

                    placeholder='Inizia a digitare'

                    aria-activedescendant={this.state.selectedId}
                    aria-label='Inizia a digitare'
                    aria-autocomplete='list'
                    aria-controls={UL_ID}
                    aria-labelledby={LABEL_ID}
                    aria-expanded={this.state.matches.length > 0}

                    onFocus={this.onFocuskHandler}
                    onChange={this.updatePartialValue}
                    onBlur={this.validate}
                    onKeyDown={this.onEdit}
                    onInput={(e) => e.currentTarget.value = (e.currentTarget.value ?? '').toUpperCase()}

                    ref={this.addressInput}

                    {...attributes}
                />
                <div className={suggestionClassName}>
                    <ul 
                        id={UL_ID}

                        className='form-control-lg  downshift-ul'

                        role='listbox'
                        aria-label='Suggerimenti per auto completamento'
                        aria-labelledby={LABEL_ID}
                    >
                        { this.state.matches.length > 0 &&
                            <>
                                {this.state.matches.map ((suggestion, index) => {
                                    const id = LI_PARTIAL_ID + index
                                    return (
                                        <li
                                            key={id}
                                            id={id}
                                            aria-selected={
                                                LI_PARTIAL_ID + index === this.state.selectedId
                                            }
                                            data-suggestion={suggestion.description}
                                            data-value={suggestion.placeId}
                                            onClick={this.selectValue}
                                        >
                                            {suggestion.description}
                                        </li>
                                    )
                                })}
                            </>
                        }
                    </ul>
                </div>
                { this.state.showCivico === true &&
                    <Input 
                        id={this.props.id + '_civico'}
                        type="text"
                        label="Civico"
                        value={this.props.number}
                        callback={this.updateNumber}
                        error={this.props.numberError}
                        bubleEvent={false}
                        regexp={STREET_NUMBER_PATTERN}
                        forceFocus={true}

                        refInput={this.numberInput}
                    />
                }
            </>
        )
    }

    private onEdit (e: KeyboardEvent) {
        if (this.timeOut) {
            clearTimeout(this.timeOut) // fiche digito pulisco il times
        }

        if (this.abortController) {
            this.abortController.abort()
        }

        this.setState ({
            isDeleteAction: (e.key === 'Delete' || e.key === 'Backspace')
        })
    }

    private onFocuskHandler (e: FocusEvent<HTMLInputElement>) {
        e.stopPropagation()

        this.setState(
            {
                hasFocus: true,
                validationError: undefined
            },
            () => {
                if (this.props.onFocus) {
                    this.props.onFocus(e)
                }
            }
        )
    }

    private validate () {
        // voglio che sia validata in ritardo.. non al click sul popup!
        setTimeout( () => {
            if ( 
                !isEmpty(this.state.value) && 
                !isValid(this.state.value, STREET_ADDRES_PATTERN) &&
                document.activeElement?.id !== 'indirizzoSedeLegale_auto' &&
                document.activeElement?.id !== 'indirizzoSedeLegale_auto'
            ) {
                this.setState({
                    validationError: 'Indirizzo non valido'
                })
            }
        }, 500)
    }

    private updatePartialValue (e: MouseEvent<HTMLInputElement>) {
        const val: string | undefined = e.currentTarget.value

        const next: any = {
            matches: []
        }

        this.setState ( 
            {
                ...next,
                ...{
                    value: val ?? '',
                    selectedId: ''
                }
            }, () => {
                if (!isEmpty(val)) {

                    this.timeOut = setTimeout( () => {
                        this.getMatches( val )
                        .then ( (match) => {
                            if (match === undefined) {
                                match = []
                            }

                            /*
                             * nessun auto completamento forzato per 1 solo risultato 
                             *
                             * Hear varia i risultati in base al più probabile.. 
                             * mi puo dare
                             * 1 solo risultato per "via dell"
                             * 3 risulati per "via delle"
                             */
                            
                            next.matches = match

                            this.setState ( 
                                next,
                                () => {
                                    if (this.props.callback && (match && match.length === 1)) {
                                        this.getDetails( match[0].id, match[0].description )
                                    }
                                }
                            )
                        })
                    }, 300)

                }

                else if (this.props.callback) {
                    // hanno cancellato il valore ..
                    this.props.callback(
                        undefined, // pStreet
                        undefined, // pStreet_number
                        undefined, // pZip
                        undefined // pCity
                    )
                }
            }
        )
    }

    private async getMatches (search: string | undefined) {
        if (search === undefined || search === '' || search.length <= 2) {
            // nulla da cercare
            return new Promise<any[]> ( (resolve) => {
                resolve( [] )
            })
        }
        else {
            return await this.getRemoteChoice(search).then( res => {
                // nota: i match son gia fatti da Hear
                return res
            })
        }
    }

    /**
     * per riempire i suggerimenti deve chiamare
     * 
     * ADDRESS_SEARCH_URL
     * 
     * che ritorna
     * 
     * {
     *      "session": "e6a066c3-39d0-4797-b655-5ee16c5b18d7",
     *      "placeList": [
     *          {
     *              "placeId": "here:af:street:KAW2b-ElNiTWXKHqmIcIFC",
     *              "description": "Via delle Rose, 00171 Roma RM, Italia"
     *          },
     *          {
     *              "placeId": "here:af:street:dPSd-0m.JS3IeI0JKoTAWA",
     *              "description": "Via delle Rose, 20094 Corsico MI, Italia"
     *          },
     *          {
     *              "placeId": "here:af:street:9wPW5uXVh63uHqhu7mwtmC",
     *              "description": "Via Monte delle Rose, 36057 Arcugnano VI, Italia"
     *          },
     *          {
     *              "placeId": "here:af:street:KOE91JQNvApcocRiZatiDA",
     *              "description": "Via delle Rose, 20025 Legnano MI, Italia"
     *          }
     *      ],
     *      "indirizzo": null
     *  }
     */
    private async getRemoteChoice (search : string) {
        this.abortController = new AbortController()

        const requestBody = {
            input: search.trim().toUpperCase()
        }

        return await authFetch (
            ADDRESS_SEARCH_URL,
            {
                method: 'post',
                body: JSON.stringify( requestBody ),
                signal: this.abortController?.signal
            },
            this.expiredSession
        )
        .then( (res: any) => {
            // salvo la sessione --> res = {session: "a", placeList: [{placeId: "aa", description: "via"}, ]}
            if ( this.state.session !== res.session ) {
                this.setState({
                    session: res.session
                })
            }

            return (res.placeList as Array<any>).map (
                (c: Place) => ({
                    placeId: c.placeId,
                    description: c.description.toUpperCase()
                }) as Place
            )
        })
        .catch( async (err) => {
            return []
        })
    }

    /**
     * 
     * per i dettagli deve chiamare
     * 
     * ADDRESS_DETAILS_URL
     * 
     * che ritorna
     * 
     * {
     *      "session": "e6a066c3-39d0-4797-b655-5ee16c5b18d7",
     *      "placeList": [
     *          {
     *              "placeId": "here:af:street:KAW2b-ElNiTWXKHqmIcIFC",
     *              "description": "Via delle Rose, 00171 Roma RM, Italia"
     *          }
     *      ],
     *      "indirizzo": {
     *          "toponimo": "Via",
     *          "address": "delle Rose",
     *          "number": null,
     *          "cap": "00171",
     *          "city": "Roma",
     *          "pv": "RM",
     *          "state": "Italia"
     *      }
     *  }
     * 
     */
    private selectValue (e: MouseEvent<HTMLLIElement>) {
        e.stopPropagation()
        e.preventDefault()

        this.addressInput.current?.focus()

        // per la prox chiamata mi seve
        const cPlaceId = e.currentTarget.getAttribute('data-value')
        const cDescription = e.currentTarget.getAttribute('data-suggestion')

        if (cPlaceId !== null && cDescription !== null) {
            this.getDetails( cPlaceId, cDescription)
        }
    }

    private getDetails (cPlaceId: string, cDescription: string ) {
        // il nuovo stato
        let next : any = {
            value: cDescription,
            selectedId: cPlaceId,
            matches: []
        }

        authFetch(
            ADDRESS_DETAILS_URL,
            {
                method: 'post',
                body: JSON.stringify({
                    placeId: cPlaceId,
                    description: cDescription,
                    session: this.state.session
                })
            },
            this.expiredSession
        )
        .then ((res: any) =>  {
            if (
                res.session && res.placeList && res.indirizzo
            ) {
                const indirizzo = res.indirizzo

                next = {
                    ...next,
                    ...{
                        session: res.session,
                        street: (indirizzo.toponimo + " " + indirizzo.address).toUpperCase(),
                        number: indirizzo.number,
                        zip: indirizzo.cap,
                        city: (indirizzo.city + " (" + indirizzo.pv + ")").toUpperCase(),
                        error: undefined,
                        showCivico: !isEmpty(indirizzo.number) && indirizzo.number === null
                    }
                }

                this.setState( 
                    next,
                    () => {
                        if (this.props.callback) {
                            this.props.callback ( 
                                // cDescription,
                                next?.street,
                                next?.number,
                                next?.zip,
                                next?.city
                             )
                        }
                    }
                )
            }
        })
        .catch (err => {
            this.setState({
                ...next,
                ...{
                    validationError: "Impossibile validare il comune selezionato"
                }
            })
        })
    }

    private updateNumber (val : string | undefined) {
        if (this.props.updateNumber) {
            this.props.updateNumber( val )
            this.clearNumberError()
        }
    }
    private clearNumberError () {

        if (this.props.clearNumberError) {
            this.props.clearNumberError()
        }
    }

    private expiredSession () {
        if (this.props.expiredSessionCallbak) {
            this.props.expiredSessionCallbak()
        }
    }

    
}

export default AutoSelectionAddress